import { action, computed, makeObservable, observable } from 'mobx';
import { AwardedNomination, Questionnaire, WinnerEvent, blankWinnerAddress } from '../../models';
import type { AwardedNominationRole } from '../../models/shared/winner-role-types';

export class ReviewQuestionnairePageUiStore {
  @observable questionnaire?: Questionnaire;

  @observable awardedNominations: AwardedNomination[] = [];

  @observable winnerEvents: WinnerEvent[] = [];

  constructor() {
    makeObservable(this);
  }

  @computed
  get awardedNomination(): AwardedNomination | undefined {
    if (!this.questionnaire) return undefined;

    const questionnaireId = this.questionnaire.questionnaireId;
    return this.awardedNominations.find(
      (awardedNomination) => awardedNomination.questionnaireId === questionnaireId,
    );
  }

  @computed
  get awardTitle(): string | undefined {
    return this.awardedNomination?.awardTitle;
  }

  @computed
  get winnerRole(): AwardedNominationRole | undefined {
    return this.awardedNomination?.role;
  }

  @action
  resetStates(): void {
    this.questionnaire = undefined;
    this.awardedNominations = [];
    this.winnerEvents = [];
  }

  @action
  setQuestionnaire(questionnaire: Questionnaire): void {
    this.questionnaire = questionnaire;

    const hasCelebratoryItemAddress = this.questionnaire.contact.addresses.some(
      (address) => address.addressTypeCode === 'Celebratory-Item',
    );
    if (!hasCelebratoryItemAddress) {
      this.questionnaire.contact.addresses.push(
        blankWinnerAddress(questionnaire.questionnaireId, 'Celebratory-Item'),
      );
    }
  }

  @action
  setAwardedNominations(awardedNominations: AwardedNomination[]): void {
    this.awardedNominations = awardedNominations;
  }

  @action
  setWinnerEvents(winnerEvents: WinnerEvent[]): void {
    this.winnerEvents = this.winnerRole === 'Both'
      ? winnerEvents
      : winnerEvents.filter((event) => event.role === this.winnerRole || event.role === 'Both');
  }
}
